import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-program-dteakwondo',
  templateUrl: './program-dteakwondo.component.html',
  styleUrls: ['./program-dteakwondo.component.scss']
})
export class ProgramDteakwondoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
